import { CardLayout } from './CardLayout';
import { CardLayoutDialog } from './CardLayoutDialog';
import { CardLayoutToolbar, CardLayoutHeader, CardLayoutTabs, CardLayoutContent } from './CardLayoutComponents';

CardLayout.Dialog = CardLayoutDialog;
CardLayout.Toolbar = CardLayoutToolbar;
CardLayout.Header = CardLayoutHeader;
CardLayout.Tabs = CardLayoutTabs;
CardLayout.Content = CardLayoutContent;

export { CardLayout, CardLayoutDialog, CardLayoutToolbar, CardLayoutHeader, CardLayoutTabs, CardLayoutContent };
export { CardLayoutDefaultToolbar } from './CardLayoutDefaultToolbar';
export { useCardLayout } from './CardLayoutContext';
